export default __webpack_public_path__ + "static/media/iconmonstr-twitter-1.cd5253c5.svg";